import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
});

export default new Vuex.Store({
  state: {
    accessToken: '',
  },
  getters: {
    isLogin(state) {
      return !!state.accessToken;
    },
  },
  mutations: {
    login(state, token) {
      state.accessToken = token;
    },
    logout(state) {
      state.accessToken = '';
    },
  },
  actions: {
    login({ commit }, token) {
      commit('login', token);
    },
    logout({ commit }) {
      commit('logout');
    },
  },
  plugins: [vuexLocal.plugin],
});
